import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { AppSettings } from '../../common/app.settings';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  data: any;
  constructor(private router: Router) {
    this.setAppSettings();
  }

  ngOnInit() {
  }

  private setAppSettings(): void {
      AppSettings.apiEndPoint = environment.apiEndPoint;
      AppSettings.envName = environment.envName;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app/app.component.ts